import { TextInput } from 'react-admin';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayLifeEducationProgrammeIntroduction = ({ index, source, }: { source: string, index: number }) => {
  return (
    <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
      sx: {
        '& .RaSimpleFormIterator-form': {
          display: 'grid',
          gap: '0px',
          columnGap: '10px',
          gridTemplateAreas: `
          'title_en title_tc title_sc'
          'sub_title_en sub_title_tc sub_title_sc'
          'sub_description_en sub_description_tc sub_description_sc'
          'sub_title_2_en sub_title_2_tc sub_title_2_sc'
          'sub_description_2_en sub_description_2_tc sub_description_2_sc'
          `
        }
      }
    }}>
      <BoundedInput source={`title_en`} input={<TextInput source="dummy" />} />
      <BoundedInput source={`title_tc`} input={<TextInput source="dummy" />} />
      <BoundedInput source={`title_sc`} input={<TextInput source="dummy" />} />

      <BoundedInput source={`sub_title_en`} input={<TextInput source="dummy" />} />
      <BoundedInput source={`sub_title_tc`} input={<TextInput source="dummy" />} />
      <BoundedInput source={`sub_title_sc`} input={<TextInput source="dummy" />} />

      <BoundedInput source={`sub_description_en`} input={<TextInput source="dummy" multiline />} />
      <BoundedInput source={`sub_description_tc`} input={<TextInput source="dummy" multiline />} />
      <BoundedInput source={`sub_description_sc`} input={<TextInput source="dummy" multiline />} />

      <BoundedInput source={`sub_title_2_en`} input={<TextInput source="dummy" />} />
      <BoundedInput source={`sub_title_2_tc`} input={<TextInput source="dummy" />} />
      <BoundedInput source={`sub_title_2_sc`} input={<TextInput source="dummy" />} />

      <BoundedInput source={`sub_description_2_en`} input={<TextInput source="dummy" multiline />} />
      <BoundedInput source={`sub_description_2_tc`} input={<TextInput source="dummy" multiline />} />
      <BoundedInput source={`sub_description_2_sc`} input={<TextInput source="dummy" multiline />} />
    </ArrayForm>
  )
}

export default ArrayLifeEducationProgrammeIntroduction;